export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}form/form-tag`;

    return $resource(url, null, {});
};



// WEBPACK FOOTER //
// ./src/app/resources/FormTag/index.js